import { TopRankTable } from '../TopRankTable'
import { withMoneySpenderTable } from './withMoneySpenderTable'

const ConnectedMoneySpenderTable = withMoneySpenderTable(TopRankTable)

export { ConnectedMoneySpenderTable as MoneySpenderTable }
